import React, { useState, useEffect } from "react";

const roleFields = [
  { name: "roleName", label: "Role Name" },
  { name: "roleDescription", label: "Role Description" },
  {
    name: "roleType",
    label: "Role Type",
    type: "select",
    options: ["Internal", "External"],
  },
  // { name: "roleOrganization", label: "Role Organization" },
  // { name: "roleModulesAccess", label: "Modules Access" },
  // { name: "roleModulesAccessLevel", label: "Modules Access Level" },
  // { name: "roleAddedBy", label: "Added By" },
  // { name: "roleAddedDate", label: "Added Date", type: "date" },
  // { name: "roleUpdatedBy", label: "Updated By" },
  // { name: "roleUpdatedDate", label: "Updated Date", type: "date" },
  // { name: "roleNoOfUsers", label: "No. of Users", type: "number" },
];

const RoleForm = ({
  initialValues = {},
  onSubmit,
  submitText = "Save",
  cancelText = "",
  onCancel = () => {},
}) => {
  const [formData, setFormData] = useState({});

  useEffect(() => {
    // Set initial values for update, or empty for create
    setFormData(
      roleFields.reduce(
        (acc, field) => ({
          ...acc,
          [field.name]: initialValues[field.name] || "",
        }),
        {}
      )
    );
    // eslint-disable-next-line
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row gy-4 gx-4 gap-4 w-80">
        {roleFields.map((field) => (
          <div className="col-md-2">
            <label className="form-label fw-semibold small">
              {field.label}
            </label>
            {field.type === "select" ? (
              <select
                className="form-select"
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required
              >
                <option value="">Select {field.label}</option>
                {field.options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={field.type || "text"}
                className="form-control"
                name={field.name}
                value={formData[field.name]}
                onChange={handleChange}
                required={field.name === "roleName"}
              />
            )}
          </div>
        ))}
      </div>
      <div className="text-end mt-4 d-flex justify-content-center mt-5">
        <div className="ms-2">
          <button type="submit" className="btn btn-secondary px-5">
            {submitText}
          </button>
        </div>
        <div className="ms-2">
          {cancelText && (
            <button onClick={()=>{onCancel({})}} className="btn btn-secondary px-5">
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </form>
  );
};

export default RoleForm;
